var PrimaryColor        = "";
var SecondayColor       = "";
var Endpoint            = "";
var MediaEndpoint       = "";
var LinkFile            = ""
var WhiteLabelApp       = "";
var AppName             = "";
var AppLogo             = "";
var InDebug             = false;
var displayOnlyDash     = false;
var MallboxVersion      = "0.0.112+2";

const setDisplayOnlyDash = () => {
    displayOnlyDash = true;
};

const setWhiteLabel = () => {

    let app           = InDebug ? "dylog" : ( window.location.hostname == '82.165.65.67' || window.location.hostname == 'dybox.dylogapp.it' || window.location.hostname == "cassawow.it" ? "dylog" : "mallbox");
    WhiteLabelApp       = app;

    if(InDebug){
        app = "dylog";
    }else{
        if(window.location.hostname == "cassawow.it"){
            app = "dylog";
        }
        if(window.location.hostname == "v2.mallbox.it"){
            app = "mallbox";
        }
        if(window.location.hostname == "testing.mallbox.it"){
            app = "mallbox_stage";
        }
        if(window.location.hostname == "gardaland.mallbox.it"){
            app = "mallbox_gardaland";
        }
    }

    switch(app){
        
        case "dylog": {
            
            AppName         = "DylogBOX 2.0";
            PrimaryColor    = '#0D600C';
            SecondayColor   = "#008833";
            MediaEndpoint   = "https://cassawow.it/files/static/media";
            LinkFile        = "https://cassawow.it/files";
            Endpoint        = "https://cassawow.it";
            AppLogo         = MediaEndpoint + "/dylog_logo.svg";

        } break;

        case "mallbox": {

            AppName         = "MallBox 2.0";
            PrimaryColor    = '#263e4f';
            SecondayColor   = "#f95f1c";
            MediaEndpoint   = "https://v2.mallbox.it/files/static/media";
            LinkFile        = "https://v2.mallbox.it/files";
            Endpoint        = "https://v2.mallbox.it";
            AppLogo         = MediaEndpoint + "/mallbox_logo.svg";

        } break;

        case "mallbox_stage": {

            AppName         = "MallBox 2.0";
            PrimaryColor    = '#263e4f';
            SecondayColor   = "#f95f1c";
            MediaEndpoint   = "https://testing.mallbox.it/files/static/media";
            LinkFile        = "https://testing.mallbox.it/files";
            Endpoint        = "https://testing.mallbox.it";
            AppLogo         = MediaEndpoint + "/mallbox_logo.svg";

        } break;

        case "mallbox_gardaland": {

            AppName         = "MallBox 2.0";
            PrimaryColor    = '#263e4f';
            SecondayColor   = "#f95f1c";
            MediaEndpoint   = "https://gardaland.mallbox.it/files/static/media";
            LinkFile        = "https://gardaland.mallbox.it/files";
            Endpoint        = "https://gardaland.mallbox.it";
            AppLogo         = MediaEndpoint + "/mallbox_logo.svg";

        } break;

    }

    if(InDebug){
        Endpoint = "https://cassawow.it";
    }

    document.querySelector(':root').style.setProperty('--primary', PrimaryColor);
};

const useProductTypePath = () => {
    if(window.location.pathname.includes("product")){
        return "product";
    }else{
        if(window.location.pathname.includes("menu")){
            return "menu";
        }
    }
    return "reparto";
};

const usePermission = () => {
    let json = "admin";
    try{
        json = JSON.parse(localStorage.getItem('role_permission'));
    }catch(_){}
    if(!json || json == "admin"){
        const json_ = {"p_easyappear":0,"p_customer_create":0,"p_customer_read":0,"p_customer_delete":0,"p_supplier_create":0,"p_supplier_read":0,"p_supplier_delete":0,"p_product_create":0,"p_product_read":0,"p_product_delete":0,"p_department_create":0,"p_department_read":0,"p_department_delete":0,"p_menu_create":0,"p_menu_read":0,"p_menu_delete":0,"p_category_create":0,"p_category_read":0,"p_category_delete":0,"p_cost_center_create":0,"p_cost_center_read":0,"p_cost_center_delete":0,"p_variant_create":0,"p_variant_read":0,"p_variant_delete":0,"p_room_create":0,"p_room_read":0,"p_room_delete":0,"p_table_create":0,"p_table_read":0,"p_table_delete":0,"p_department_production_create":0,"p_department_production_read":0,"p_department_production_delete":0,"p_document_create":0,"p_document_read":0,"p_document_delete":0,"p_logger_h":0,"p_logger_i":0,"p_logger_n": 0,"p_myenterprise_create":0,"p_myenterprise_read":0,"p_myenterprise_delete":0,"p_enterprise_create":0,"p_enterprise_read":0,"p_enterprise_delete":0,"p_storage_create":0,"p_storage_read":0,"p_storage_delete":0,"p_causal_create":0,"p_causal_read":0,"p_causal_delete":0,"p_office_create":0,"p_office_read":0,"p_office_delete":0,"p_operator_create":0,"p_operator_read":0,"p_operator_delete":0,"p_um_create":0,"p_um_read":0,"p_um_delete":0,"p_vat_create":0,"p_vat_read":0,"p_vat_delete":0,"p_list_price_create":0,"p_list_price_read":0,"p_list_price_delete":0,"p_payment_create":0,"p_payment_read":0,"p_payment_delete":0,"p_device_create":0,"p_device_read":0,"p_device_delete":0,"p_param_create":0,"p_param_read":0,"p_param_delete":0,"p_discount_rule_create":0,"p_discount_rule_read":0,"p_discount_rule_delete":0,"p_summary_payments_create":0,"p_summary_payments_read":0,"p_summary_payments_delete":0,"p_supervisor_key_create":0,"p_supervisor_key_read":0,"p_supervisor_key_delete":0,"p_profile_create":0,"p_profile_read":0,"p_profile_delete":0, "p_subuser_create": 0, "p_subuser_read": 0, "p_subuser_delete": 0, "p_general_setting_create": 0, "p_general_setting_read": 0, "p_general_setting_delete": 0,"p_launch_cloud_command":0,"p_tipology":0,"p_logger_l":0}
        Object.keys(json_).forEach(i => json_[i] = 1);
        return json_;
    }else{
        return json;
    }
}

var RefreshToken = false;
const setRefreshToken = (value) => RefreshToken = value;

var InitDashboard = false;
const setInitDashBoard = (value) => InitDashboard = value;

var Permission = null;
const setPermission = (value) => Permission = value;

var IsSubUser = false;
const setIsSubUser = (value) => IsSubUser = value;

var EnterpriseType = "";
const setEnterpriseType = (value) => EnterpriseType = value;

var PassedFromLogin = false;
const _PassedFromLogin = (value) => { PassedFromLogin = value; };

var EnterpriseDto;
const setEnterpriseDto = (value) => EnterpriseDto = value;

var DrawerScroll;
const setDrawerScroll = (value) => DrawerScroll = value;

var CheckedWizard;
const setCheckedWizard = (value) => CheckedWizard = value;

var InitConfig;
const setInitConfig = (value) => InitConfig = value;

var RecordsForPage;
const setRecordsForPage = (value) => {
    RecordsForPage = value;
    localStorage.setItem('record_for_page', value);
};

var RegisteredFetchListener = false;
const setFetchListener = (value) =>  RegisteredFetchListener = value;

var CurrentPathName = null;
const setCurrentPathName = (value) => CurrentPathName = value;

const getRecordForPage = () => {
    let local = localStorage.getItem('record_for_page');
    if(!local){
        localStorage.setItem('record_for_page', '10');
        local = 10;
    }else{
        local = parseInt(local);
    }
    RecordsForPage = local;
};

const RemoveHash = () => {
    window.location.hash = "";
    var noHashURL = window.location.href.replace(/#.*$/, '');
    window.history.replaceState('', document.title, noHashURL) 
};

const SaveAna = (e) => {
    if(e.key == 'Enter'){
        const btnSave = document.querySelector('#btn_save');
        if(document.activeElement !== btnSave)
            btnSave.click();
    }
};

const getDayName = (day) => {
    switch(day){
        case 1: {
            return "Lunedì";
        }
        case 2: {
            return "Martedì";
        }
        case 3: {
            return "Mercoledì";
        }
        case 4: {
            return "Giovedì";
        }
        case 5: {
            return "Venerdì";
        }
        case 6: {
            return "Sabato";
        }
        case 7: {
            return "Domenica";
        }
    }
};

const getMonthName = (day) => {
    switch(day){
        case 1: {
            return "Gennaio";
        }
        case 2: {
            return "Febbraio";
        }
        case 3: {
            return "Marzo";
        }
        case 4: {
            return "Aprile";
        }
        case 5: {
            return "Maggio";
        }
        case 6: {
            return "Giugno";
        }
        case 7: {
            return "Luglio";
        }
        case 8: {
            return "Agosto";
        }
        case 9: {
            return "Settembre";
        }
        case 10: {
            return "Ottobre";
        }
        case 11: {
            return "Novembre";
        }
        case 12: {
            return "Dicembre";
        }
    }
};

var GettedParams = false;
const setGettedParams = (value) => GettedParams = value;

function getBase64Image(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

function base64toBlob(base64Data, contentType) {
    contentType = contentType || '';
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);

        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
}

const createHours = () => {
    const hours = [];
    for(let i = 0; i < 25; i++){
        hours.push(i.toString().padStart(2, "0") + ":00");
        if(i < 24){
            hours.push(i.toString().padStart(2, "0") + ":30");
        }
    }
    return hours;
};

export {
    PrimaryColor,
    SecondayColor,
    Endpoint,
    PassedFromLogin,
    _PassedFromLogin,
    EnterpriseDto,
    setEnterpriseDto,
    RecordsForPage,
    setRecordsForPage,
    getRecordForPage,
    RemoveHash,
    SaveAna,
    GettedParams,
    setGettedParams,
    getBase64Image,
    base64toBlob,
    RegisteredFetchListener,
    setFetchListener,
    getDayName,
    MediaEndpoint,
    getMonthName,
    CurrentPathName,
    setCurrentPathName,
    EnterpriseType,
    setEnterpriseType,
    LinkFile,
    AppName,
    setWhiteLabel,
    AppLogo,
    IsSubUser,
    setIsSubUser,
    Permission,
    setPermission,
    InitDashboard,
    setInitDashBoard,
    createHours,
    WhiteLabelApp,
    RefreshToken,
    setRefreshToken,
    DrawerScroll,
    setDrawerScroll,
    CheckedWizard,
    setCheckedWizard,
    InitConfig,
    setInitConfig,
    InDebug,
    displayOnlyDash,
    setDisplayOnlyDash,
    usePermission,
    useProductTypePath,
    MallboxVersion
}